/* Vianne bridge client — ADDITIVE ONLY.
   The native /contact submission (and Shopify's captcha) is never intercepted:
   no preventDefault, no form.submit(), no fetch-based submitting. This script
   only (1) mirrors the application to the bridge as the page navigates away,
   and (2) powers the resale-certificate upload. If the bridge is unreachable,
   the form behaves exactly as it does today. */
(function () {
  var form = document.getElementById('RequestAccountForm');
  if (!form) return;
  var meta = form.querySelector('[data-vjw-bridge]');
  var BRIDGE = meta ? (meta.getAttribute('data-vjw-bridge') || '').trim().replace(/\/+$/, '') : '';
  if (!BRIDGE) return;
  var SEP = BRIDGE.indexOf('?') === -1 ? '?' : '&';
  function endpoint(action) { return BRIDGE + SEP + 'action=' + action; }

  var MAP = {
    name: 'contact[name]',
    email: 'contact[email]',
    phone: 'contact[Phone]',
    role: 'contact[Role]',
    business_name: 'contact[Business Name]',
    dba: 'contact[DBA]',
    business_type: 'contact[Business Type]',
    years_in_business: 'contact[Years in Business]',
    website: 'contact[Website]',
    instagram: 'contact[Instagram]',
    country: 'contact[Country]',
    address: 'contact[Address]',
    tax_id: 'contact[Tax ID]',
    resale_cert_url: 'contact[Resale Cert URL]',
    annual_volume: 'contact[Annual Volume]',
    product_interest: 'contact[Product Interest]',
    price_point: 'contact[Price Point]',
    payment_terms: 'contact[Payment Terms]',
    referral_source: 'contact[How did you hear about us]',
    referred_by: 'contact[Referred By]',
    notes: 'contact[body]'
  };

  function field(name) {
    var el = form.elements.namedItem(name);
    return el || null;
  }

  /* ---- mirror the submission to the bridge (fire-and-forget) ---- */
  form.addEventListener('submit', function () {
    try {
      var params = new URLSearchParams();
      Object.keys(MAP).forEach(function (k) {
        var el = field(MAP[k]);
        if (el && el.value) params.append(k, el.value);
      });
      var hp = field('vjw-extra');
      params.append('hp', hp ? hp.value : '');
      var url = endpoint('submit');
      var sent = false;
      if (navigator.sendBeacon) {
        try { sent = navigator.sendBeacon(url, params); } catch (e) { sent = false; }
      }
      if (!sent && window.fetch) {
        fetch(url, { method: 'POST', body: params, keepalive: true }).catch(function () {});
      }
    } catch (e) {
      /* the email path is the source of truth — never interfere with submit */
    }
  });

  /* ---- certificate upload (progressive enhancement) ---- */
  var wrap = form.querySelector('[data-ra-upload]');
  var fileInput = form.querySelector('[data-ra-file]');
  var trigger = form.querySelector('[data-ra-upload-trigger]');
  var labelEl = form.querySelector('[data-ra-upload-label]');
  var hintEl = form.querySelector('[data-ra-upload-hint]');
  var certInput = field('contact[Resale Cert URL]');
  if (!wrap || !fileInput || !trigger || !certInput || !window.fetch) return;

  var HINT_DEFAULT = hintEl ? hintEl.textContent : '';

  (function healthCheck() {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
    fetch(endpoint('health'), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ok) wrap.hidden = false; })
      .catch(function () {})
      .then(function () { if (timer) clearTimeout(timer); });
  })();

  trigger.addEventListener('click', function () { fileInput.click(); });

  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (!f) return;
    if (f.size > 8 * 1024 * 1024) {
      return fail('Over 8 MB — try a smaller file, or paste a link below.');
    }
    if (!/\.(pdf|jpe?g|png|webp|heic)$/i.test(f.name)) {
      return fail('PDF or image files only — or paste a link below.');
    }
    setState('busy', 'Attaching…', f.name);
    trigger.disabled = true;
    var fd = new FormData();
    fd.append('file', f, f.name);
    fetch(endpoint('upload'), { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        trigger.disabled = false;
        if (j && j.ok && j.url) {
          certInput.value = j.url;
          certInput.readOnly = true;
          fileInput.value = '';
          setState('done', 'Attached ✓', f.name);
        } else {
          fail('Couldn’t attach it — paste a link below instead.');
        }
      })
      .catch(function () {
        trigger.disabled = false;
        fail('Couldn’t attach it — paste a link below instead.');
      });
  });

  function setState(cls, label, hint) {
    wrap.classList.remove('ra-upload--busy', 'ra-upload--done', 'ra-upload--error');
    if (cls) wrap.classList.add('ra-upload--' + cls);
    if (labelEl && label) labelEl.textContent = label;
    if (hintEl) hintEl.textContent = (hint == null) ? HINT_DEFAULT : hint;
  }

  function fail(msg) {
    fileInput.value = '';
    certInput.readOnly = false;
    setState('error', 'Attach the certificate', msg);
  }
})();
